'use strict';

import {addCustomEventListener, hasClass, addClass, removeClass} from './helpers';

export const popups = (() => {
  const popName = 'sh-popup';
  const popClass = `.${popName}`;
  const _body = document.body;
  let popup = null;

  const popupToggle = () => {
    const headerHeight = document.querySelector('.header').clientHeight;

    if (hasClass(popup, `${popName}--showed`)) {
      removeClass(popup, `${popName}--showed`);
      removeClass(_body, 'is-locked');
    } else {
      if (!hasClass(_body, 'is-touch-device')) {
        popup.querySelector('.sh-popup__inner').style.top = `${headerHeight}px`;
      }
      addClass(popup, `${popName}--showed`);
      addClass(_body, 'is-locked');
    }
  };

  const eventListeners = () => {

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        if (document.querySelector(`.${popName}--showed`)) {
          document.querySelector(`.${popName}--showed [data-type="popup-toggle"]`).click(); // close all popups
        }
      }
    });

    addCustomEventListener('[data-type="popup-toggle"]', 'click', popupToggle);
  };

  const init = () => {
    popup = document.querySelector(popClass);
    if (!popup) {
      return false;
    }
    eventListeners();
    window.shApp.hidePopup = () => {
      if (hasClass(popup, `${popName}--showed`)) {
        removeClass(popup, `${popName}--showed`);
      }
    }
  };

  return {
    init
  }
})();
